import React, { useState } from "react";
import { Button, Form, Input } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";
import { showLoading, hideLoading } from "../redux/alertsSlice";
import "../auth.css";

/* ─── Icons ─────────────────────────────────────────────── */
const IconKey = () => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0 3 3L22 7l-3-3m-3.5 3.5L19 4"/>
  </svg>
);
const IconMail = () => (
  <svg className="auth-input-icon" viewBox="0 0 24 24">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const IconArrowLeft = () => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round">
    <line x1="19" y1="12" x2="5" y2="12"/>
    <polyline points="12 19 5 12 12 5"/>
  </svg>
);

function ResetPassword() {
  const dispatch  = useDispatch();
  const navigate  = useNavigate();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      dispatch(showLoading());
      const response = await axios.post("/api/reset-Password/generate-reset-otp", values);
      dispatch(hideLoading());
      if (response.data.success) {
        toast.success(response.data.message);
        navigate("/confirm-otp", { state: { email: values.email } });
      } else {
        toast.error(response.data.message);
      }
    } catch {
      dispatch(hideLoading());
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-cloud auth-cloud-1" />
      <div className="auth-cloud auth-cloud-2" />
      <div className="auth-cloud auth-cloud-3" />

      <div className="auth-card">
        <div className="auth-icon-wrap">
          <IconKey />
        </div>

        <h1 className="auth-title">Forgot your password?</h1>
        <p className="auth-subtitle">
          Enter your registered email and we'll send you a secure one-time code to reset your password.
        </p>

        <Form layout="vertical" onFinish={onFinish} className="auth-form">
          <Form.Item name="email"
            rules={[
              { required: true, message: "Email is required" },
              { type: "email",  message: "Enter a valid email" },
            ]}>
            <div className="auth-input-wrap">
              <IconMail />
              <Input placeholder="Email" size="large" />
            </div>
          </Form.Item>

          {/* Tip note */}
          <div className="auth-note">
            <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            <p>Check your spam or junk folder if you don't see the code within a few minutes.</p>
          </div>

          <Form.Item>
            <Button htmlType="submit" loading={loading} className="auth-btn">
              {loading ? "Sending…" : "Send Reset Code"}
            </Button>
          </Form.Item>
        </Form>

        <Link to="/login" className="auth-back">
          <IconArrowLeft /> Back to login
        </Link>
      </div>
    </div>
  );
}

export default ResetPassword;